import { Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core'
import { IconComponent } from 'src/app/elements/icon/icon.component'

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.sass',
  imports: [IconComponent],
})
export class TooltipComponent {
  protected clone?: HTMLDivElement
  @ViewChild('content') contentRef!: ElementRef<HTMLDivElement>

  @HostListener('mouseenter') onEnter () {
    this.show()
  }

  @HostListener('mouseleave') onLeave () {
    this.hide()
  }

  constructor (
    protected renderer2: Renderer2,
  ) {
  }

  protected show () {
    const content = this.contentRef.nativeElement
    content.style.display = 'block'
    const rect = content.getBoundingClientRect()

    this.clone = content.cloneNode(true) as HTMLDivElement
    Object.assign(this.clone.style, {
      position: 'fixed',
      zIndex: 10000,
      top: rect.top + 'px',
      left: rect.left + 'px',
      width: rect.width + 'px',
      height: rect.height + 'px',
    })

    this.renderer2.appendChild(document.body, this.clone)
    content.style.display = 'none'
  }

  protected hide () {
    if (!this.clone) {
      return
    }
    this.clone.remove()
  }
}
